// ShiftPage.jsx
import * as React from 'react';
import {
    Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle,
    Grid2, MenuItem, Stack, TextField
} from '@mui/material';
import dayjs from 'dayjs';
import { getShiftsData, getSingleShift, updateShift, addShift } from '../../features/AdminManagement/shiftsSlice';
import { useDispatch, useSelector } from 'react-redux';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import HeadingText from '../../BuiltInComponent/HeadingTest';
import Loading from '../../BuiltInComponent/Loading';
import Navbar from '../setup/Navbar'

const defaultValues = {
    shiftName: '',
    startTime: '09:00:00',
    endTime: '17:00:00',
    breakMinutes: 60,
    graceInMinutes: 5,
    graceOutMinutes: 5,
    weeklyOff: 'SUN',
    remarks: '',
    status: 'active'
};

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

export default function ShiftPage() {

    const dispatch = useDispatch();

    const { shiftsData, isLoading } = useSelector((state) => state.shifts);
    // const [rows, setRows] = React.useState([]);
    // const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [editRow, setEditRow] = React.useState(null);

    const [form, setForm] = React.useState(defaultValues);
    const [errors, setErrors] = React.useState({});

    React.useEffect(() => {
        dispatch(getShiftsData())
    }, [dispatch]);

    const onCreate = () => {
        setEditRow(null);
        setForm(defaultValues);
        setErrors({});
        setOpen(true);
    };

    const onEdit = async (shiftID) => {
        dispatch(getSingleShift({ shiftID: shiftID })).then((res) => {
            const row = res.payload[0];
            setEditRow(row);
            setForm({
                shiftName: row.shiftName ?? '',
                startTime: row.startTime ?? '09:00:00',
                endTime: row.endTime ?? '17:00:00',
                breakMinutes: Number(row.breakMinutes ?? 0),
                graceInMinutes: Number(row.graceInMinutes ?? 0),
                graceOutMinutes: Number(row.graceOutMinutes ?? 0),
                weeklyOff: row.weeklyOff ?? 'SUN',
                remarks: row.remarks ?? '',
                status: row.status ?? 'active'
            });

        })
        setErrors({});
        setOpen(true);
    };

    const onDelete = async (id) => {
        console.log('Delete shiftID:', id);
        // if (!window.confirm('Delete this shift?')) return;
        // try {
        //     await deleteShift(id);
        //     dispatch(getShiftsData());
        // } catch (e) {
        //     console.error(e);
        //     alert('Failed to delete.');
        // }
    };

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'number' ? Number(e.target.value) : e.target.value;
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const validate = () => {
        const next = {};
        if (!form.shiftName?.trim()) next.shiftName = 'Required';
        if (!timeRegex.test(form.startTime)) next.startTime = 'Format HH:MM:SS (24h)';
        if (!timeRegex.test(form.endTime)) next.endTime = 'Format HH:MM:SS (24h)';

        // Optional: end must be after start (same-day)
        if (timeRegex.test(form.startTime) && timeRegex.test(form.endTime)) {
            const s = dayjs(`2000-01-01 ${form.startTime}`);
            const e = dayjs(`2000-01-01 ${form.endTime}`);
            if (!e.isAfter(s)) next.endTime = 'End must be after Start';
        }

        if (form.breakMinutes < 0) next.breakMinutes = 'Must be ≥ 0';
        if (form.graceInMinutes < 0) next.graceInMinutes = 'Must be ≥ 0';
        if (form.graceOutMinutes < 0) next.graceOutMinutes = 'Must be ≥ 0';

        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const onSave = async () => {
        console.log('Saving', form);
        if (!validate()) return;
        try {
            if (editRow?.shiftID) {
                dispatch(updateShift({ shiftID: editRow.shiftID, form }));
            } else {
                dispatch(addShift({ form }));
            }
            setOpen(false);
            dispatch(getShiftsData());
        } catch (e) {
            console.error(e);
            alert('Failed to save.');
        }
    };

    const weeklyOffOptions = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT", "SAT,SUN"];

    return (
        <>
            <Navbar />
            <Container maxWidth="lg" sx={{ py: 3 }}>
                <HeadingText text="Shift Management" />
                <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
                    <Button variant="contained" onClick={onCreate}>New Shift</Button>
                </Stack>

                {/* === Replace this block with your own TableDataWithPagination if you prefer === */}
                {isLoading ? <><Loading /></> :
                    <>
                        <TableDataWithPagination
                            tableData={shiftsData && shiftsData}
                            tableColumns={[
                                { fieldName: 'shiftID', cName: 'Shift ID', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'shiftName', cName: 'Shift Desc', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'startTime', cName: 'Star Time', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'endTime', cName: 'End Time', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'breakMinutes', cName: 'Breack Min', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'graceInMinutes', cName: 'Grace In Minute', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'graceOutMinutes', cName: 'Grace Out Min', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'weeklyOff', cName: 'Weekly Off', width: 10, textAlign: 'left', status: 'en' },
                                // { fieldName: 'status', cName: 'Menu ID', width: 10, textAlign: 'left', status: 'en' },
                                { fieldName: 'edit', cName: 'Edit', width: 10, textAlign: 'center', status: 'en' },
                                { fieldName: 'delete', cName: 'Delete', width: 10, textAlign: 'center', status: 'dis' },
                                { fieldName: 'delete', cName: 'Delete', width: 10, textAlign: 'center', status: 'dis' },
                            ]}
                            onEditClick={onEdit}
                            onDeleteClick={onDelete}
                            perPage={5}
                        />
                    </>
                }
                <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>{editRow ? 'Edit Shift' : 'Create Shift'}</DialogTitle>
                    <DialogContent>
                        <Box component="form" id="shift-form" onSubmit={(e) => e.preventDefault()} sx={{ mt: 1 }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={6}>
                                    <TextField
                                        label="Shift Name"
                                        fullWidth
                                        size="small"
                                        value={form.shiftName}
                                        onChange={handleChange('shiftName')}
                                        error={!!errors.shiftName}
                                        helperText={errors.shiftName}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <TextField
                                        label="Start (HH:MM:SS)"
                                        fullWidth
                                        size="small"
                                        placeholder="09:00:00"
                                        value={form.startTime}
                                        onChange={handleChange('startTime')}
                                        error={!!errors.startTime}
                                        helperText={errors.startTime}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <TextField
                                        label="End (HH:MM:SS)"
                                        fullWidth
                                        size="small"
                                        placeholder="17:00:00"
                                        value={form.endTime}
                                        onChange={handleChange('endTime')}
                                        error={!!errors.endTime}
                                        helperText={errors.endTime}
                                    />
                                </Grid2>

                                <Grid2 size={4}>
                                    <TextField
                                        type="number"
                                        label="Break Minutes"
                                        fullWidth
                                        size="small"
                                        value={form.breakMinutes}
                                        onChange={handleChange('breakMinutes')}
                                        error={!!errors.breakMinutes}
                                        helperText={errors.breakMinutes}
                                    />
                                </Grid2>

                                <Grid2 size={4}>
                                    <TextField
                                        type="number"
                                        label="Grace In (min)"
                                        fullWidth
                                        size="small"
                                        value={form.graceInMinutes}
                                        onChange={handleChange('graceInMinutes')}
                                        error={!!errors.graceInMinutes}
                                        helperText={errors.graceInMinutes}
                                    />
                                </Grid2>

                                <Grid2 size={4}>
                                    <TextField
                                        type="number"
                                        label="Grace Out (min)"
                                        fullWidth
                                        size="small"
                                        value={form.graceOutMinutes}
                                        onChange={handleChange('graceOutMinutes')}
                                        error={!!errors.graceOutMinutes}
                                        helperText={errors.graceOutMinutes}
                                    />
                                </Grid2>

                                <Grid2 size={6}>
                                    <TextField
                                        select
                                        label="Weekly Off"
                                        fullWidth
                                        size="small"
                                        value={form.weeklyOff}
                                        onChange={handleChange('weeklyOff')}
                                    >
                                        {weeklyOffOptions.map(v => (
                                            <MenuItem key={v} value={v}>{v}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid2>

                                <Grid2 size={6}>
                                    <TextField
                                        select
                                        label="Status"
                                        fullWidth
                                        size="small"
                                        value={form.status}
                                        onChange={handleChange('status')}
                                    >
                                        <MenuItem value="active">active</MenuItem>
                                        <MenuItem value="inactive">inactive</MenuItem>
                                    </TextField>
                                </Grid2>

                                <Grid2 size={12}>
                                    <TextField
                                        label="Remarks"
                                        fullWidth
                                        size="small"
                                        multiline
                                        rows={2}
                                        value={form.remarks}
                                        onChange={handleChange('remarks')}
                                    />
                                </Grid2>
                            </Grid2>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)}>Cancel</Button>
                        <Button variant="contained" onClick={onSave}>Save</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
}
